import { render, staticRenderFns } from "./BtnInserirRahtEmpresa.vue?vue&type=template&id=edb29ade"
import script from "./BtnInserirRahtEmpresa.vue?vue&type=script&lang=js"
export * from "./BtnInserirRahtEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports